import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TagIcon = styled(FontAwesomeIcon)`
  font-size: 10px;
`;

const TagContainer = styled.div`
background-color: white;
border-radius: 14px;
padding: 2px 16px;
display: flex;
align-items: center;
`;

const TagText = styled.p`
  font-family: 'futura-pt', sans-serif;
  margin-bottom: 0;
  font-size: 14px;
  margin-left: 5px;
`;

export default ({icon, text, ...props}) => (
  <TagContainer {...props}>
    <TagIcon icon={icon} />
    <TagText>{text}</TagText>
  </TagContainer>
);
